import { LOCALE } from '@/legacy-src/constants/locale.constants'

import { CMSMenuSchema, type CMSMenuItem } from '@/src/domains/cms-menus/schemas'
import { fetchStrapiMenu, type FetchStrapiMenu } from '@/src/domains/strapi/services/fetchStrapiMenu'

export const getCMSMenuSWRKey = (slug: FetchStrapiMenu['slug']) => `strapi-menu-${slug}-${LOCALE}`

export const fetchCMSMenu = async (slug: FetchStrapiMenu['slug']): Promise<CMSMenuItem[]> => {
  try {
    const data = await fetchStrapiMenu({
      slug,
      query: {
        populate: {
          items: {
            populate: {
              children: {
                populate: {
                  page_relation_one: {
                    fields: ['slug', 'category'],
                  },
                },
              },
              page_relation_one: {
                fields: ['slug', 'category'],
              },
            },
          },
        },
      },
      schema: CMSMenuSchema,
    })

    return data?.items ?? []
  } catch {
    return []
  }
}
